import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Form } from "react-bootstrap";
import _ from "lodash";

import { table_tabs, div_title, first, last } from "../../maintainers.module.scss";

const UsersRoles = ({ data, setData }) => {
	const location = useLocation();

	const { roles, estates, estates_parents, customers } = useSelector((state) => state.maintainers_users);
	const { user } = useSelector((state) => state.auth);

	const handleChangeSelected = (e, i) => {
		let new_roles = [...data.roles];
		let new_estates = [...data.estates];
		let new_estates_parents = data.estates_parents ? [...data.estates_parents] : [];

		const isEquals = (element) => Number(element) === Number(roles[i].id);
		const index_user_role = data.roles.findIndex(isEquals);

		if (e.target.checked) {
			if (index_user_role === -1) {
				new_roles.push(roles[i].id);
			}
		} else {
			if (index_user_role !== -1) {
				new_roles.splice(index_user_role, 1);
			}
		}

		if ((new_roles.includes(7) || new_roles.includes(1)) && user.superuser) {
			let customer_id = data.customer_id;
			if (!customer_id && location.pathname.includes("configuracion")) {
				customer_id = user.customer.id;
			}

			const selectCustomer = customers.find((c) => Number(c.value) === Number(customer_id));

			if (selectCustomer) {
				const all_estates_parents = estates_parents.filter((e) => Number(e.customer_id) === Number(customer_id));
				new_estates_parents = _.map(all_estates_parents, "value");
				const all_estates = estates.filter((e) => Number(e.customer_id) === Number(customer_id));
				new_estates = _.map(all_estates, "value");
			} else {
				const all_estates = estates.filter((e) => Number(e.customer_id) === Number(customer_id));
				new_estates = _.map(all_estates, "value");
			}
		}

		handlePermissions(new_roles);
		setData({ ...data, roles: new_roles, estates: new_estates, estates_parents: new_estates_parents });
	};

	const handlePermissions = (roles) => {
		let newPermissions = data.permissions;
		newPermissions.forEach((permission, j) => {
			let newDetails = [...permission.details];
			newDetails.forEach((detail, k) => {
				newDetails[k].value = false;

				// Usuario
				if (roles.includes(2)) {
					if (detail.permission === "show") {
						newDetails[k].value = true;
					}
				}

				// Administrador Campo
				if (roles.includes(3)) {
					if (["show", "create", "edit"].includes(detail.permission)) {
						newDetails[k].value = true;
					}
				}

				// Gerente Agricola / Admin
				if (roles.includes(7) || roles.includes(1)) {
					if (["show", "create", "edit", "delete", "approve"].includes(detail.permission)) {
						newDetails[k].value = true;
					}
				}
			});

			newPermissions[j].details = newDetails;
		});
	};

	return (
		<table className={table_tabs} border="0" cellSpacing="0" cellPadding="0">
			<thead>
				<tr>
					<th style={{ width: "15%" }}>
						<div className={`${div_title} ${first}`}>#</div>
					</th>
					<th>
						<div className={`${div_title} ${last}`}>Descripción</div>
					</th>
				</tr>
			</thead>
			<tbody>
				{roles.map((rol, i) => {
					return (
						<tr key={i}>
							<td style={{ textAlign: "center" }}>
								<Form.Check
									type="switch"
									id={`switch_role_${i}`}
									checked={data && data.roles && data.roles.includes(Number(rol.id)) ? true : false}
									onChange={(e) => handleChangeSelected(e, i)}
								/>
							</td>
							<td>{rol.name}</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};

export default UsersRoles;
